export default __webpack_public_path__ + "static/media/website.ca39fc0a.png";